import React, { Component } from "react";
import { connect } from "react-redux";
import { AddDeviceDialog } from "../dialogs/AddDeviceDialog";

export class AddDevice extends Component {

  state = {}

  render() {
    const {onClose, deviceGroups} = this.props;
    return <AddDeviceDialog 
      onClose={onClose}
      deviceGroups={deviceGroups}
    />;
  }
}

const mapStateToProps = state => ({
  deviceGroups: state.data.deviceGroups
});

const mapDispatchToProps = { };

export default connect(mapStateToProps, mapDispatchToProps)(AddDevice);
